"use strict";
var Observable_1 = require('../../Observable');
var mergeAll_1 = require('../../operator/mergeAll');
Observable_1.Observable.prototype.mergeAll = mergeAll_1.mergeAll;
//# sourceMappingURL=mergeAll.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/add/operator/mergeAll.js
// module id = ./node_modules/rxjs/add/operator/mergeAll.js
// module chunks = vendor